<template>
  <div>
    <div :class="{ 'has-error': $v.student.cpf.$error }" class="control-group col-lg-6">
      <label class="control-label" for="cpf">CPF *</label>
      <div class="controls">
        <input
          type="text"
          v-model="student.cpf"
          class="form-control cpf-field"
          maxlength="14"
          autocomplete="off"
        />
      </div>
    </div>

    <div v-if="false" :class="{ 'has-error': $v.student.gender.$error }" class="control-group col-lg-6">
      <label class="control-label" for="sexo">Sexo *</label>
      <select v-model="student.gender" id="status" class="form-control">
        <option disabled value>Escolha um tipo</option>
        <option v-for="g in genderList" v-bind:key="g.key" v-bind:value="g.key">{{g.value}}</option>
      </select>
    </div>

    <div v-if="false" :class="{ 'has-error': $v.student.email.$error }" class="control-group col-lg-6">
      <label class="control-label" for="student.email">E-mail</label>
      <div class="controls">
        <input
          v-model="student.email"
          type="text"
          name="student.email"
          maxlength="255"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="status">Escolaridade *</label>
      <select
        :class="{ 'has-error': $v.student.scholarity.$error }"
        v-model="student.scholarity"
        id="status"
        class="form-control"
        @change="checkScholarity($event)"
      >
        <option disabled value>Escolha um tipo</option>
        <option v-for="s in scholarityList" v-bind:key="s.key" v-bind:value="s.key">{{s.value}}</option>
      </select>
    </div>

    <div v-if="false" :class="{ 'has-error': $v.student.trainingArea.$error }" class="control-group col-lg-6">
      <label class="control-label" for="trainingArea">Área de atuação *</label>
      <div class="controls">
        <input
          :disabled="student.scholarity == 1"
          name="trainingArea"
          v-model="student.trainingArea"
          type="text"
          maxlength="255"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="nameFather">Nome da Mãe</label>
      <div class="controls">
        <input
          type="text"
          name="student.mothersName"
          maxlength="255"
          v-model="student.mothersName"
          id="save_student_student_motherName"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="nameFather">Nome do Pai</label>
      <div class="controls">
        <input
          type="text"
          name="student.fathersName"
          v-model="student.fathersName"
          maxlength="255"
          id="save_student_student_fatherName"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="cpf">Nacionalidade</label>
      <div class="controls">
        <input
          v-model="student.nationality"
          type="text"
          name="student.nationality"
          id="nationality"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <div id="uflist">
        <label class="control-label" for="cpf">Naturalidade (UF)</label>
        <div class="controls">
          <input
            v-model="student.naturalnessUf"
            type="text"
            name="student.naturalnessUF"
            id="naturalnessUF"
            class="form-control"
          />
        </div>
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <div id="city">
        <label class="control-label" for="cpf">Naturalidade (Cidade)</label>
        <div class="controls">
          <input
            v-model="student.naturalnessCity"
            type="text"
            name="student.naturalness"
            id="naturalness"
            class="form-control"
          />
        </div>
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="maritalStatus">Estado Civil</label>
      <div class="controls">
        <select v-model="student.maritalStatus" id="maritalStatus" class="form-control">
          <option disabled value>Escolha um tipo</option>
          <option v-for="m in maritalStatusList" v-bind:key="m.key" v-bind:value="m.key">{{m.value}}</option>
        </select>
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="rg">RG</label>
      <div class="controls">
        <input v-model="student.rg" type="text" name="rg" id="rg" class="form-control" />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="issuingAuthority">Órgão Emissor</label>
      <div class="controls">
        <input
          v-model="student.issuingAuthority"
          type="text"
          name="issuingAuthority"
          id="issuingAuthority"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="issuingAuthorityUf">UF Orgão Emissor</label>
      <div class="controls">
        <input
          v-model="student.issuingAuthorityUf"
          type="text"
          name="issuingAuthorityUf"
          id="issuingAuthorityUf"
          class="form-control"
        />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="issuanceDate">Data de Emissão (RG)</label>
      <div class="controls">
        <date-input class="form-control" v-model="student.issuanceDate"></date-input>
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="identidade">Data de Nascimento</label>
      <div class="controls">
        <date-input class="form-control" v-model="student.birthdate"></date-input>
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="phone">Telefone</label>

      <div class="controls">
        <input v-model="student.phone" type="text" name="phone" id="phone" class="form-control" />
      </div>
    </div>

    <div v-if="false" class="control-group col-lg-6">
      <label class="control-label" for="mobilePhone">Celular</label>

      <div class="controls">
        <input
          v-model="student.mobilePhone"
          type="text"
          name="mobilePhone"
          id="mobilePhone"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>


<style scoped>
.has-error {
  border-color: #a94442 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
}
</style>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import axios from "axios";
let config = require("../../../const.json");

axios.defaults.withCredentials = true;

export default {
  props: ["student"],
  data() {
    return {
      // scholarityList: config.user.scholarity,
      // genderList: config.user.gender,
      // maritalStatusList: config.user.maritalStatus
    };
  },
  validations: {
    student: {
      //birthdate, gender, "mobilePhone", phone,
      // cpf: { required },
      // email: { required },
      // scholarity: { required },
      // trainingArea: { required },
      // gender: { required }
    }
  },
  computed: {},
  components: {},
  methods: {
    checkScholarity(event) {
      if (event.target.value == 1) {
        this.student.trainingArea = "-";
      } else {
        this.student.trainingArea = "";
      }
    },
    hasErrors() {
      this.$v.student.$touch();
      if (this.$v.student.$error) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {}
};
</script>
